<template>
  <v-card>
    <v-card-title>
      {{ $t("fund.report.minimalRequirements.title") }}
    </v-card-title>

    <v-simple-table class="v-align-top table-no-hover">
      <template #default>
        <tbody>
          <template v-for="(category, index) in categories">
            <tr :key="index">
              <td colspan="2">
                <h3>
                  {{ $t(`minimalRequirementCategory.${index}.name`) }}
                </h3>
              </td>
            </tr>

            <tr v-for="requirement in category" :key="requirement.id">
              <td width="50%">
                <strong>
                  {{ $t(`minimalRequirement.${requirement.requirementId}.name`) }}
                </strong>

                <Markdown :value="$t(`minimalRequirement.${requirement.requirementId}.description`)" />

                <Markdown :value="$t(`minimalRequirement.${requirement.requirementId}.help`)" />
              </td>

              <td width="50%">
                <ResponseList :responses="requirement.protocol" />

                <Feedback :requirement="requirement" />
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import groupByCategory from "@/utils/Requirements/groupByCategory";
import ResponseList from "@/components/Fund/ResponseList";
import Feedback from "./Feedback.vue";

export default {
  components: {
    ResponseList,
    Feedback,
  },

  props: {
    requirements: {
      type: Array,
      required: true,
    },
  },

  computed: {
    categories() {
      return groupByCategory(this.requirements);
    },
  },
};
</script>
